import UserTypes from 'store/actionTypes/appUser'
import { appUserAPI, notificationAPI } from 'store/api'
import { bindRequestLogic } from './utils'
import { mapUserSubscriptions } from '../mapping'

const getUserSubscription = bindRequestLogic({
  clientFunc: appUserAPI.getUserSubscription,
  type: UserTypes.GET_USER_SUBSCRIPTION_REQUEST,
  successType: UserTypes.GET_USER_SUBSCRIPTION_SUCCESS,
  failType: UserTypes.GET_USER_SUBSCRIPTION_FAILED,
  isQueryParam: true,
  mapResponse: mapUserSubscriptions
})

const getSubscriptionAllowedPilots = bindRequestLogic({
  clientFunc: appUserAPI.getSubscriptionAllowedPilots,
  type: UserTypes.GET_SUBSCRIPTION_ALLOWED_PILOTS_REQUEST,
  successType: UserTypes.GET_SUBSCRIPTION_ALLOWED_PILOTS_SUCCESS,
  failType: UserTypes.GET_SUBSCRIPTION_ALLOWED_PILOTS_FAILED,
  isQueryParam: false
})

const getListIndividualVehicleSharingExtension = bindRequestLogic({
  clientFunc: appUserAPI.getListVehicleSharingExtension,
  type: UserTypes.GET_LIST_VEHICLES_SHARING_EXTENSION_REQUEST,
  successType: UserTypes.GET_LIST_VEHICLES_SHARING_EXTENSION_SUCCESS,
  failType: UserTypes.GET_LIST_VEHICLES_SHARING_EXTENSION_FAILED,
  isQueryParam: false
})

const getDetailIndividualVehicleSharing = bindRequestLogic({
  clientFunc: appUserAPI.getDetailVehicleSharing,
  type: UserTypes.GET_DETAIL_VEHICLES_SHARING_REQUEST,
  successType: UserTypes.GET_DETAIL_VEHICLES_SHARING_SUCCESS,
  failType: UserTypes.GET_DETAIL_VEHICLES_SHARING_FAILED,
  isQueryParam: false
})

const forceStatusPermanentExtension = bindRequestLogic({
  clientFunc: appUserAPI.forceStatusPermanentExtension,
  type: UserTypes.FORCE_STATUS_PERMANENT_EXTENSION_REQUEST,
  successType: UserTypes.FORCE_STATUS_PERMANENT_EXTENSION_SUCCESS,
  failType: UserTypes.FORCE_STATUS_PERMANENT_EXTENSION_FAILED
})

const forceStatusTemporalExtension = bindRequestLogic({
  clientFunc: appUserAPI.forceStatusTemporalExtension,
  type: UserTypes.FORCE_STATUS_TEMPORAL_EXTENSION_REQUEST,
  successType: UserTypes.FORCE_STATUS_TEMPORAL_EXTENSION_SUCCESS,
  failType: UserTypes.FORCE_STATUS_TEMPORAL_EXTENSION_FAILED
})

const forceStatusUniqueExtension = bindRequestLogic({
  clientFunc: appUserAPI.forceStatusUniqueExtension,
  type: UserTypes.FORCE_STATUS_UNIQUE_EXTENSION_REQUEST,
  successType: UserTypes.FORCE_STATUS_UNIQUE_EXTENSION_SUCCESS,
  failType: UserTypes.FORCE_STATUS_UNIQUE_EXTENSION_FAILED
})

const forceStatusCheckIn = bindRequestLogic({
  clientFunc: appUserAPI.forceStatusCheckIn,
  type: UserTypes.FORCE_STATUS_CHECK_IN_REQUEST,
  successType: UserTypes.FORCE_STATUS_CHECK_IN_SUCCESS,
  failType: UserTypes.FORCE_STATUS_CHECK_IN_FAILED
})

const forceStatusCheckOut = bindRequestLogic({
  clientFunc: appUserAPI.forceStatusCheckOut,
  type: UserTypes.FORCE_STATUS_CHECK_OUT_REQUEST,
  successType: UserTypes.FORCE_STATUS_CHECK_OUT_SUCCESS,
  failType: UserTypes.FORCE_STATUS_CHECK_OUT_FAILED
})

const getNotificationPushByEmail = bindRequestLogic({
  clientFunc: notificationAPI.getNotificationPushById,
  type: UserTypes.GET_NOTIFICATION_PUSH_REQUEST,
  successType: UserTypes.GET_NOTIFICATION_PUSH_SUCCESS,
  failType: UserTypes.GET_NOTIFICATION_PUSH_FAILED,
  isQueryParam: true
})

const getNotificationInAppsByEmail = bindRequestLogic({
  clientFunc: notificationAPI.getNotificationInApps,
  type: UserTypes.GET_NOTIFICATION_IN_APPS_REQUEST,
  successType: UserTypes.GET_NOTIFICATION_IN_APPS_SUCCESS,
  failType: UserTypes.GET_NOTIFICATION_IN_APPS_FAILED,
  isQueryParam: true
})

export default [
  getUserSubscription,
  getListIndividualVehicleSharingExtension,
  getDetailIndividualVehicleSharing,
  getSubscriptionAllowedPilots,
  forceStatusPermanentExtension,
  forceStatusTemporalExtension,
  forceStatusUniqueExtension,
  forceStatusCheckIn,
  forceStatusCheckOut,
  getNotificationPushByEmail,
  getNotificationInAppsByEmail
]
